import { z } from "zod";
import { AnswerKeySchema, FieldValueSchema, SentAnswersSchema, } from "../form-engine/answers.js";
import { SessionNoteValuesSchema } from "./session-note-values.js";
// A session's note: the template it is written from and the version of it the
// note was started against, what has been entered, and the revision this save
// of it is. The revision counts saves from 1, so a save can say which revision
// it was based on.
export const SessionNoteSchema = z.object({
    templateId: z.guid(),
    templateVersion: z.int().positive(),
    answers: z.record(AnswerKeySchema, FieldValueSchema),
    revision: z.int().positive(),
});
// What starting a note carries: its template, the version of it the page showed
// (the fields the answers were entered against, ADR-032 P), and the answers.
// The server gives the note its first revision.
export const CreateSessionNoteSchema = z.object({
    templateId: z.guid(),
    templateVersion: z.int().positive(),
    answers: SentAnswersSchema,
});
// What updating a note carries: its answers, whole, and the revision the update
// is based on. The template is fixed when the note is started, so there is
// nothing else to change.
export const UpdateSessionNoteSchema = z.object({
    answers: SentAnswersSchema,
    revision: z.int().positive(),
});
// The note as the practitioner API responds with it: the note, with its values
// as SessionNoteValuesSchema has them, its changeable fields among the answers at the
// record's values (ADR-039 decision 11).
export const SessionNoteResponseSchema = SessionNoteSchema.extend(SessionNoteValuesSchema.shape);
// What a client is told about a session's note beyond its status, as an
// error's code (ADR-033 rule 7). Server and client both name them from here, so
// a code cannot change on one side alone.
export const SessionNoteErrorCodeSchema = z.enum([
    "NO_SESSION_NOTE",
    "SESSION_NOTE_EXISTS",
    "SESSION_NOTE_CHANGED",
    "NO_TEMPLATE_VERSION",
    "ANSWERS_DO_NOT_FIT",
    "ANSWER_REQUIRED",
    "BOUND_VALUE_REFUSED",
    "SESSION_CLOSED",
]);
export const SessionNoteErrorCode = SessionNoteErrorCodeSchema.enum;
